export default __webpack_public_path__ + "static/media/home.49a07b71.png";